import moment from 'moment';

angular.module('shbdeployer.app').controller('ProjectController', [
  '$scope',
  '$state',
  '$stateParams',
  '$interval',
  'ProjectService',
  'ModalService',
  'Notifications',
  'clipboard',
  'Container',
  'LogHelper',
  function ($scope, $state, $stateParams, $interval, ProjectService, ModalService, Notifications, clipboard, Container, LogHelper) {
    $scope.state = {
      actionInProgress: false,
      redeployInProgress: false,
      statusLoading: false,
      uploadValidationError: '',
      showNginxConfig: false,
      nginxConfigLoading: false,
      sourceMethod: 'upload',
      selectedContainerId: null,
      logsLoading: false,
      lineCount: 300,
      sinceTimestamp: '',
      displayTimestamps: false,
    };

    // eslint-disable-next-line no-empty-function
    $scope.noop = function () {};

    $scope.formValues = {
      Name: '',
      Description: '',
      ZipFile: null,
      SourceURL: '',
    };

    $scope.uploadFile = function (file) {
      $scope.formValues.ZipFile = file;
      $scope.state.uploadValidationError = '';
      if (file && !/\.zip$/i.test(file.name)) {
        $scope.state.uploadValidationError = 'Выберите файл с расширением .zip';
        $scope.formValues.ZipFile = null;
      }
    };

    $scope.updateDetails = function () {
      $scope.state.actionInProgress = true;
      ProjectService.updateProject($stateParams.id, $scope.formValues.Name, $scope.formValues.Description, null, null)
        .then(function success() {
          Notifications.success('Проект обновлен', $scope.formValues.Name);
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось обновить проект');
        })
        .finally(function final() {
          $scope.state.actionInProgress = false;
        });
    };

    $scope.redeploy = function () {
      var isUpload = $scope.state.sourceMethod === 'upload';

      if (isUpload && !$scope.formValues.ZipFile) {
        $scope.state.uploadValidationError = 'Загрузите новую версию ZIP-архива';
        return;
      }
      if (!isUpload && !$scope.formValues.SourceURL) {
        $scope.state.uploadValidationError = 'Укажите ссылку на новую версию ZIP-архива';
        return;
      }

      $scope.state.redeployInProgress = true;
      ProjectService.updateProject(
        $stateParams.id,
        $scope.formValues.Name,
        $scope.formValues.Description,
        isUpload ? $scope.formValues.ZipFile : null,
        isUpload ? null : $scope.formValues.SourceURL
      )
        .then(function success() {
          Notifications.success('Новая версия проекта развернута', $scope.formValues.Name);
          $scope.formValues.ZipFile = null;
          $scope.formValues.SourceURL = '';
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось развернуть новую версию проекта');
        })
        .finally(function final() {
          $scope.state.redeployInProgress = false;
        });
    };

    $scope.removeAction = function () {
      ModalService.confirmDeletion(
        'Проект и все его данные (включая развёрнутые контейнеры) будут удалены без возможности восстановления. Продолжить?',
        function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          deleteProject();
        }
      );
    };

    function deleteProject() {
      $scope.state.actionInProgress = true;
      ProjectService.remove($stateParams.id)
        .then(function success() {
          Notifications.success('Проект удален', $scope.project.Name);
          $state.go('shbdeployer.projects');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить проект');
          $scope.state.actionInProgress = false;
        });
    }

    function refreshStatus() {
      $scope.state.statusLoading = true;
      ProjectService.status($stateParams.id)
        .then(function success(data) {
          $scope.status = data;
          if (!$scope.state.selectedContainerId && data.Containers.length > 0) {
            $scope.state.selectedContainerId = data.Containers[0].Id;
          }
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить состояние проекта');
        })
        .finally(function final() {
          $scope.state.statusLoading = false;
        });
    }

    $scope.refreshStatus = refreshStatus;

    $scope.loadLogs = function () {
      var containerId = $scope.state.selectedContainerId;
      if (!containerId || !$scope.project) {
        return;
      }

      $scope.state.logsLoading = true;
      Container.get({ endpointId: $scope.project.EndpointId, id: containerId })
        .$promise.then(function success(container) {
          var skipHeaders = !container.Config.Tty;
          return Container.logs({
            endpointId: $scope.project.EndpointId,
            id: containerId,
            stdout: 1,
            stderr: 1,
            timestamps: $scope.state.displayTimestamps ? 1 : 0,
            since: $scope.state.sinceTimestamp ? moment($scope.state.sinceTimestamp).unix() : 0,
            tail: $scope.state.lineCount || 300,
          }).$promise.then(function success(data) {
            $scope.logs = LogHelper.formatLogs(data.logs, skipHeaders);
          });
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить журнал контейнера');
        })
        .finally(function final() {
          $scope.state.logsLoading = false;
        });
    };

    $scope.toggleNginxConfig = function () {
      $scope.state.showNginxConfig = !$scope.state.showNginxConfig;
      if ($scope.state.showNginxConfig && !$scope.nginxConfig) {
        $scope.state.nginxConfigLoading = true;
        ProjectService.nginxConfig($stateParams.id)
          .then(function success(data) {
            $scope.nginxConfig = data;
          })
          .catch(function error(err) {
            Notifications.error('Ошибка', err, 'Не удалось получить конфигурацию nginx');
          })
          .finally(function final() {
            $scope.state.nginxConfigLoading = false;
          });
      }
    };

    $scope.copyNginxConfig = function () {
      clipboard.copyText($scope.nginxConfig);
      Notifications.success('Готово', 'Конфигурация скопирована в буфер обмена');
    };

    var statusInterval = $interval(refreshStatus, 10000);
    $scope.$on('$destroy', function () {
      $interval.cancel(statusInterval);
    });

    function initView() {
      ProjectService.project($stateParams.id)
        .then(function success(data) {
          $scope.project = data;
          $scope.formValues.Name = data.Name;
          $scope.formValues.Description = data.Description;
          refreshStatus();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить проект');
        });
    }

    initView();
  },
]);
